import React, { useMemo } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Paper,
} from "@mui/material";
import { RET_IR_OPTIONS, RET_IVA_OPTIONS } from "../../Empresa/NuevaFactura/InvoiceRetention/Retention";

const num2 = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n.toFixed(2) : "0.00";
};

export default function InvoiceRetention({ doc }) {
  const rows = useMemo(() => {
    return Array.isArray(doc?.retenciones_detalle)
      ? doc.retenciones_detalle
      : [];
  }, [doc]);

  const mapIR = useMemo(() => {
    const m = new Map();
    RET_IR_OPTIONS.forEach((x) => {
      m.set(String(x.codigo).trim(), x.descripcion);
    });
    return m;
  }, []);

  const mapIVA = useMemo(() => {
    const m = new Map();
    RET_IVA_OPTIONS.forEach((x) => {
      m.set(String(x.codigo).trim(), x.descripcion);
    });
    return m;
  }, []);

  const total = useMemo(() => {
    return rows.reduce((a, r) => a + Number(r.valor || 0), 0);
  }, [rows]);

  const getDescripcion = (r) => {
    const cod = String(r.codigo_retencion || "").trim();
    if (String(r.codigo) === "2") {
      return mapIVA.get(cod) || `Código ${cod}`;
    }
    return mapIR.get(cod) || `Código ${cod}`;
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper
        sx={{
          border: "1px solid #e6e6e6",
          borderRadius: 1.5,
          overflow: "hidden",
        }}
      >
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: "#f3f4f6" }}>
              <TableCell sx={{ fontWeight: 700 }}>Retención</TableCell>
              <TableCell sx={{ width: 120, fontWeight: 700 }}>Tipo</TableCell>
              <TableCell sx={{ width: 110, fontWeight: 700 }}>Cod. SRI</TableCell>
              <TableCell sx={{ width: 130, fontWeight: 700 }}>Base</TableCell>
              <TableCell sx={{ width: 80, fontWeight: 700 }}>%</TableCell>
              <TableCell sx={{ width: 130, fontWeight: 700 }}>Valor</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6}>
                  <Typography sx={{ py: 2, color: "#6b7280" }}>
                    Este documento no tiene retenciones.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((r, i) => (
                <TableRow key={i}>
                  <TableCell>
                    <TextField
                      value={getDescripcion(r)}
                      fullWidth
                      size="small"
                      disabled
                      sx={{
                        "& .Mui-disabled": {
                          backgroundColor: "#fff !important",
                          WebkitTextFillColor: "#111827 !important",
                        },
                      }}
                    />
                  </TableCell>

                  <TableCell>
                    <Typography sx={{ color: "#111827" }}>
                      {String(r.codigo) === "2" ? "IVA" : "Imp. a la Renta"}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography sx={{ color: "#111827" }}>
                      {r.codigo_retencion}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <TextField
                      value={num2(r.base_imponible)}
                      size="small"
                      disabled
                      fullWidth
                      inputProps={{ style: { textAlign: "right" } }}
                      sx={{
                        "& .Mui-disabled": {
                          backgroundColor: "#f3f4f6 !important",
                          WebkitTextFillColor: "#111827 !important",
                        },
                      }}
                    />
                  </TableCell>

                  <TableCell>
                    <TextField
                      value={num2(r.porcentaje)}
                      size="small"
                      disabled
                      fullWidth
                      inputProps={{ style: { textAlign: "right" } }}
                      sx={{
                        "& .Mui-disabled": {
                          backgroundColor: "#f3f4f6 !important",
                          WebkitTextFillColor: "#111827 !important",
                        },
                      }}
                    />
                  </TableCell>

                  <TableCell>
                    <TextField
                      value={num2(r.valor)}
                      size="small"
                      disabled
                      fullWidth
                      inputProps={{ style: { textAlign: "right" } }}
                      sx={{
                        "& .Mui-disabled": {
                          backgroundColor: "#f3f4f6 !important",
                          WebkitTextFillColor: "#111827 !important",
                        },
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))
            )}

            {rows.length > 0 && (
              <TableRow>
                <TableCell colSpan={5} sx={{ textAlign: "right", fontWeight: 700 }}>
                  Total retenciones
                </TableCell>
                <TableCell>
                  <TextField
                    value={num2(total)}
                    size="small"
                    disabled
                    fullWidth
                    inputProps={{ style: { textAlign: "right", fontWeight: 700 } }}
                    sx={{
                      "& .Mui-disabled": {
                        backgroundColor: "#f3f4f6 !important",
                        WebkitTextFillColor: "#111827 !important",
                      },
                    }}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
